import React, { ReactNode } from 'react';
import { UrlDTO } from '../../../../api/core/models';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { IntlShape, useIntl } from 'react-intl';
import { getDefaultUrl } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { InputGroup } from '../layout/InputGroup';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { Panel } from '../layout/Panel';


interface UrlsProps {
  checkPermission: CheckPermissionFunction;
  urls: UrlDTO[];
  onChange: (url: UrlDTO[]) => void;
  typelist: string;
  validation?: ValidationResult;
  title: string;
  autoFocus: boolean;
}

export function Urls(props: UrlsProps): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <Panel
      title={props.title}
      toggleable={true}>
      <MultiInputControls<UrlDTO>
        canEdit={props.checkPermission().canWrite}
        addNew={(urls: UrlDTO[]): number => urls.push(getDefaultUrl())}
        lines={props.urls}
        onChange={props.onChange}
        renderLines={(urlObject: UrlDTO, onLineChange: (newValue: UrlDTO) => void, actions: Actions, idx: number): ReactNode => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledInputText
                id={`url-${idx}-url`}
                autoFocus={props.autoFocus}
                value={urlObject.url}
                permissions={props.checkPermission('url')}
                validation={props.validation?.children[idx]?.fields?.url}
                onChange={(url: string): void => onLineChange({...urlObject, url})}
                label={`${props.title}.attr.url`}
                className={'w-15rem'}
              />
              <LabelledDropdown
                id={`url-${idx}-type`}
                value={urlObject.type}
                permissions={props.checkPermission('type')}
                validation={props.validation?.children[idx]?.fields?.type}
                options={getVocabularyOptions(intl.locale, props.typelist)}
                onChange={(type: any): void => onLineChange({...urlObject, type})}
                label={`${props.title}.attr.type`}
                className={'w-15rem'}
              />
            </InputGroup>
          );
        }}
      />
    </Panel>
  );
}
